// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS (globális adat). A repo oxlint konfigja a
 * TS+build világra van hangolva, ami erre a szigetre nem alkalmazható és valódi
 * hibát nem fog. Ezért kikapcsoljuk; build esetén TS-re konvertálandó. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM archívum – MOCK adat.
 *
 * Ez ideiglenes, példa tartalom, hogy a felület kész legyen, mielőtt a valós
 * archívumot bekötjük. A média-forrás (YouTube / audio / külső link) még nem
 * dőlt el, ezért a `mediaUrl` mező most üres — a kártya „Meghallgatás –
 * hamarosan” állapotot mutat, amíg ki nem töltjük.
 *
 * ÉLES ADATRA CSERÉLÉS:
 *   - Töltsd fel ezt a tömböt a valós műsorokkal (vagy generáld build-lépésből).
 *   - Egy elem szerkezete:
 *       {
 *         id:          egyedi azonosító (string),
 *         title:       műsor címe (string),
 *         date:        'ÉÉÉÉ-HH' vagy 'ÉÉÉÉ' formátumú megjelenítendő dátum (string),
 *         category:    kategória neve (string) – a szűrő-chipek ebből épülnek,
 *         description: rövid ismertető (string),
 *         mediaUrl:    lejátszható/megnyitható link, üres ha még nincs (string)
 *       }
 *
 * Klasszikus <script>-ként töltjük be (nem ES module / fetch), hogy `file://`
 * protokollon is működjön, build nélkül. Ezért globális változóba tesszük.
 */
window.TUDASFM_ARCHIVE = [
  {
    id: 'nyelvorseg-01',
    title: 'Nyelvőrség – A magyar helyesírás rejtelmei',
    date: '2011-03',
    category: 'Nyelvtanulás',
    description:
      'Gyakorlatias epizód a leggyakoribb helyesírási buktatókról: egybe- és különírás, a -ba/-be és -ban/-ben párok, valamint a vesszőhasználat.',
    mediaUrl: '',
  },
  {
    id: 'csillagos-eg-02',
    title: 'Csillagos ég – Bevezetés a csillagászatba',
    date: '2011-05',
    category: 'Természettudomány',
    description:
      'Mitől ragyognak a csillagok, hogyan tájékozódtak régen a hajósok, és miért látjuk másképp az égboltot a különböző évszakokban.',
    mediaUrl: '',
  },
  {
    id: 'idogep-honfoglalas-03',
    title: 'Időgép – A honfoglalástól az államalapításig',
    date: '2011-09',
    category: 'Történelem',
    description:
      'Kalandozó séta a korai magyar történelemben: törzsek, vezérek, és az első évszázad legfontosabb fordulópontjai közérthetően.',
    mediaUrl: '',
  },
  {
    id: 'fejszamolo-04',
    title: 'Fejszámoló – Trükkök a gyorsabb számoláshoz',
    date: '2012-01',
    category: 'Természettudomány',
    description:
      'Fejben szorzás, osztás és becslés egyszerű fogásokkal. Olyan módszerek, amelyek a hétköznapokban és a dolgozatban is jól jönnek.',
    mediaUrl: '',
  },
  {
    id: 'vilagnyelv-angol-05',
    title: 'Világnyelv – Angol kezdőknek, félelem nélkül',
    date: '2012-04',
    category: 'Nyelvtanulás',
    description:
      'Az első mondatok, a leggyakoribb 100 szó és a kiejtés alapjai. Beszédközpontú megközelítés, sok ismételhető példával.',
    mediaUrl: '',
  },
  {
    id: 'tanulasmodszertan-06',
    title: 'Fejben tartva – Tanulásmódszertan diákoknak',
    date: '2012-10',
    category: 'Készségfejlesztés',
    description:
      'Hogyan tervezz vizsgaidőszakot, hogyan jegyzetelj hatékonyan, és mi a különbség a magolás meg a valódi megértés között.',
    mediaUrl: '',
  },
  {
    id: 'elo-termeszet-07',
    title: 'Élő természet – A sejtektől az ökoszisztémáig',
    date: '2013-02',
    category: 'Természettudomány',
    description:
      'A biológia nagy összefüggései egy adásban: mi a közös az emberben, a fában és a baktériumban, és hogyan kapcsolódik minden mindenhez.',
    mediaUrl: '',
  },
  {
    id: 'szoszatyar-08',
    title: 'Szószátyár – Szónoklás és magabiztos beszéd',
    date: '2013-06',
    category: 'Készségfejlesztés',
    description:
      'Lámpaláz, testbeszéd és felépítés: gyakorlatias tanácsok ahhoz, hogy közönség előtt is nyugodtan és érthetően fejezd ki magad.',
    mediaUrl: '',
  },
  {
    id: 'regmult-nagy-felfedezesek-09',
    title: 'Régmúlt – A nagy földrajzi felfedezések',
    date: '2013-11',
    category: 'Történelem',
    description:
      'Hajók, térképek és bátor utazók kora. Miért indultak útnak a felfedezők, és hogyan formálta át a világot, amit találtak.',
    mediaUrl: '',
  },
];
